<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.848"
        height="17.941"
        viewBox="0 0 23.848 17.941"
    >
        <g
            id="Gruppe_381"
            data-name="Gruppe 381"
            transform="translate(-0.002 0)"
        >
            <g id="Gruppe_380" data-name="Gruppe 380">
                <path
                    id="Pfad_14"
                    data-name="Pfad 14"
                    d="M13.662.1,7.09,3.879V14.064l6.572,3.779c.543.311,1.175-.151,1.175-.856V.956C14.837.25,14.2-.213,13.662.1Z"
                    transform="translate(-0.787 -0.001)"
                    :class="fillClass + ' transition-fill'"
                />
                <path
                    id="Pfad_15"
                    data-name="Pfad 15"
                    d="M4.485,5.727.8,5.734a.885.885,0,0,0-.8.881c0,.021,0,.043,0,.064v7.664c0,.019,0,.041,0,.063a.872.872,0,0,0,.794.869H4.484V5.726Z"
                    transform="translate(0.004 -1.446)"
                    :class="fillClass + ' transition-fill'"
                />
            </g>
            <path
                id="Pfad_16"
                data-name="Pfad 16"
                d="M25.261,10.03v.007a3.164,3.164,0,0,1-.537,1.769l.007-.011a2.971,2.971,0,0,1-1.383,1.159l-.019.007a.684.684,0,0,1-.286.061h-.034a.775.775,0,0,1-.552-.23.761.761,0,0,1-.237-.552v-.016h0V12.2a.67.67,0,0,1,.151-.425h0a1.468,1.468,0,0,1,.355-.308l.006,0q.212-.131.424-.287a1.251,1.251,0,0,0,.358-.442l0-.007a1.739,1.739,0,0,0,0-1.417l0,.011a1.257,1.257,0,0,0-.359-.447l0,0q-.212-.156-.424-.287a1.471,1.471,0,0,1-.36-.309v0a.669.669,0,0,1-.15-.424v-.02h0V7.82a.76.76,0,0,1,.236-.552.774.774,0,0,1,.552-.231h.034a.683.683,0,0,1,.29.064h0a2.887,2.887,0,0,1,1.4,1.151l.007.012a3.18,3.18,0,0,1,.53,1.768h0Zm3.194,0v.028a6.267,6.267,0,0,1-1.074,3.518l.014-.022a6.2,6.2,0,0,1-2.767,2.336l-.04.015a.867.867,0,0,1-.312.061h-.014a.778.778,0,0,1-.561-.237.766.766,0,0,1-.237-.554v-.007h0v0a.792.792,0,0,1,.484-.73l.005,0a7.708,7.708,0,0,0,.974-.567l-.026.017a4.771,4.771,0,0,0,.013-7.7L24.9,6.178a7.438,7.438,0,0,0-.9-.53l-.045-.02a.794.794,0,0,1-.49-.732v0a.809.809,0,0,1,.8-.8h0a.884.884,0,0,1,.33.064l-.006,0a6.194,6.194,0,0,1,2.792,2.327l.014.024a6.24,6.24,0,0,1,1.06,3.5v.029h0Z"
                transform="translate(-4.605 -1.034)"
                :class="fillClass + ' transition-fill'"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "VolumeFullIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
